const tagGroups = [
  {
    label: '运动健身',
    tags: ['健身', '跑步', '游泳', '篮球', '足球', '瑜伽', '骑行', '徒步', '羽毛球', '乒乓球', '网球', '滑雪', '攀岩']
  },
  {
    label: '文艺生活',
    tags: ['阅读', '电影', '音乐', '摄影', '绘画', '写作', '手工', '乐器', '书法', '舞蹈', '戏剧']
  },
  {
    label: '美食',
    tags: ['做饭', '烘焙', '品酒', '咖啡', '下午茶', '美食探店', '火锅', '烧烤']
  },
  {
    label: '旅行户外',
    tags: ['旅行', '自驾游', '露营', '潜水', '冲浪', '钓鱼', '登山']
  },
  {
    label: '社交娱乐',
    tags: ['桌游', '狼人杀', '密室逃脱', 'KTV', '电竞', '剧本杀', '派对']
  },
  {
    label: '生活',
    tags: ['养宠物', '园艺', '养花', '追剧', '动漫', '逛街', '穿搭', '美妆', '数码']
  },
  {
    label: '自我提升',
    tags: ['学外语', '编程', '投资理财', '心理学', '冥想', '早起', '考证']
  }
];

export default tagGroups;
